import React, { useEffect, useState } from "react";
import {
    Container,
    Button,
    Alert,
    AlertTitle,
    Dialog,
    DialogTitle,
    IconButton,
    DialogContent,
    DialogActions,
    Box
} from "@mui/material";
import { PersonPinCircleOutlined } from "@material-ui/icons";
import CloseIcon from "@mui/icons-material/Close";
import * as api from "../../api"
import { guardarIibbCliente } from "../../savefunctions"
import InscripcionesExclusionesForm from "./InscripcionesExclusionesForm";
import Notify from "../../../../../../Notify";
import AvisoNoHayConvenio from "./AvisoNoHayConvenio"
import PadronPercepcionesTabla from "./PadronPercepcionesTabla";
import DialogoIngresosBrutos from "./DialogoIngresosBrutos"
import { getData } from "../../../../../../../services/library";

export default function InscripcionesExclusionesContainer({ open, setOpen, cliente, cicloFiscalActual, showUpdates }) {
    const icono = <PersonPinCircleOutlined />
    const [provincias, setProvincias] = useState([{}]);
    const [inscrIIBB, setInscrIIBB] = useState([]);
    const [clienteIIBBOriginal, setClienteIIBBOriginal] = useState(null);
    const [padronIIBB, setPadronIIBB] = useState(null); //Son las percepciones que vienen por padron
    const [notify, setNotify] = useState({
        open: false,
        severity: "",
        color: "",
        mensaje: "",
    });
    const [showCargaProxPeriodo, setShowCargaProxPeriodo] = useState();
    const [showAlertProxCiclo, setShowAlertProxCiclo] = useState();

    const configConvenio = JSON.parse(cliente?.config_convenio) || {}
    const hayConvenio = Object.values(configConvenio)?.length > 0

    const [openPadronDialog, setOpenPadronDialog] = useState(false);

    const handleClose = () => {
        setOpen(false)
    }

    useEffect(() => {
        api.getIIBBPadrones(cliente?.cuit, setPadronIIBB);
        getData("/provincias/all/datos_iibb", setProvincias);
    }, [])

    const setearClienteIIBB = (data) => {
        const dataConId = data && data.length > 0 ? data.map((item, index) => ({
            ...item,
            tempId: item.tempId || item.id_provincia || `iibb_${index}`
        })) : [{
            tempId: Date.now(),
            cuit: cliente?.cuit,
            percepcion: "",
            id_provincia: "",
            porcentaje_excencion: "",
            vto_excencion: ""
        }];
        setInscrIIBB(dataConId);
        setClienteIIBBOriginal(data ? JSON.parse(JSON.stringify(data)) : []);
    };

    const [obtenidos, setObtenidos] = useState(false); //indica que se terminaron de buscar los datos de las inscripciones para que si hay registros en el padron, los pueda setear como inscripcion. basicamente es una bandera.

    //2 - busco las inscripciones manuales y los registros del padron
    useEffect(() => {
        if (padronIIBB && (cicloFiscalActual?.id_ciclo || (cicloFiscalActual?.id_ciclo === null))) {
            // console.log("Voy a buscar las inscripciones en useEffect linea 82.")
            api.getInscripcionesCiclo(cliente.cuit, cicloFiscalActual?.id_ciclo, setearClienteIIBB, configConvenio?.max_inscripciones, setObtenidos, padronIIBB)
        }
    }, [cicloFiscalActual, padronIIBB])

    useEffect(() => {
        const maximoInscripciones = Number(configConvenio?.max_inscripciones)
        const unaSolaInscrPermitida = maximoInscripciones === 1;
        
        if (((inscrIIBB?.length > maximoInscripciones) || (padronIIBB?.length > maximoInscripciones))) {
            alert("Las inscripciones registradas / registros en padrones no son coherentes con el convenio del cliente. Por favor, revise la condición de ingresos brutos de este cliente.")
        }

        const noHayInscrCargadas = !(inscrIIBB?.some((ib) => ib.id_provincia ))

        if(noHayInscrCargadas && padronIIBB?.length == 1) alert(`Este cliente no tiene ninguna inscripción registrada en sistema, pero se ha encontrado en el padrón de ${padronIIBB[0].provincia}. La inscripción se registrará automáticamente al presionar "guardar".`)

        if (obtenidos && noHayInscrCargadas && unaSolaInscrPermitida && padronIIBB?.length == 1) {
            setInscrIIBB([{
                cuit: cliente.cuit,
                percepcion: padronIIBB[0]?.percepcion || "",
                id_provincia: padronIIBB[0]?.id_provincia || "",
                porcentaje_excencion: padronIIBB[0]?.porcentaje_excencion || "",
                vto_excencion: padronIIBB[0]?.vto_excencion || "",
                iibb_auto: true
            }])
        } else if(obtenidos && noHayInscrCargadas && unaSolaInscrPermitida && padronIIBB?.length > 1) {
            setInscrIIBB([{
                cuit: cliente.cuit,
                percepcion: "0.00",
                id_provincia: "" ,
                porcentaje_excencion: "",
                vto_excencion: "",
                iibb_auto: true
            }])
        }
    }, [obtenidos])


    // console.log(padronIIBB)

    const almacenarImpuesto = () => {
        const values = [...inscrIIBB];
        values.push({
            tempId: Date.now(),
            cuit: cliente.cuit,
            percepcion: "",
            id_provincia: "",
            porcentaje_excencion: "",
            vto_excencion: "",
        });
        setInscrIIBB(values);
    };

    const deshacerAlmacenar = (field) => {
        if (inscrIIBB.length === 1) {
            setInscrIIBB([
                {
                    tempId: Date.now(), 
                    cuit: cliente?.cuit,
                    percepcion: "",
                    id_provincia: "",
                    fecha_vigencia_desde: "",
                    porcentaje_excencion: "",
                    vto_excencion: ""
                },
            ]);
        } else {
            const values = inscrIIBB.filter((item) => item.tempId !== field.tempId);
            setInscrIIBB(values);
        }
    };

    const handleInputChange = (rowKey, event) => {
        const updatedValue = event.target.name;
        const newValue = event.target.value;

        setInscrIIBB((prevInscr) =>
            prevInscr.map((item) => {
                if (item.tempId === rowKey) {
                    return { ...item, [updatedValue]: newValue };
                }
                return item;
            })
        );
    };
    
    const handleInputChangeProvincia = (rowKey, event) => {
        const idProvinciaSel = event.target.value;

        const dataProvincia = provincias?.find(
            provincia => provincia.id === idProvinciaSel
        );
    
        setInscrIIBB((prevInscr) =>
            prevInscr.map((item) => {
                if (item.tempId === rowKey) {
                    return {
                        ...item,
                        id_provincia: idProvinciaSel,
                        percepcion: dataProvincia?.iibb_auto
                            ? padronIIBB?.find(
                                padron => padron.id_provincia === idProvinciaSel
                            )?.percepcion || null
                            : dataProvincia?.percepcion || 0,
                        impuestoPadron: dataProvincia?.iibb_auto,
                        deshabilitaPercepcion:
                            dataProvincia?.percepcion_fija == 1 ||
                            dataProvincia?.iibb_auto == 1
                    };
                }
    
                return item;
            })
        );
    };


    // const handleInputChangeProvincia = (index, event, provincias, iibbPadrones) => {
    //     const values = [...inscrIIBB];
    //     const idProvinciaSel = event.target.value;
    //     const dataProvincia = provincias.find(provincia => provincia.id === idProvinciaSel);
    //     // const exencionVigente = exencionesVigentes?.find(ex=>ex.id_provincia==idProvinciaSel);

    //     if (dataProvincia?.iibb_auto) {
    //         values[index]["percepcion"] = iibbPadrones.find(padron => padron.id_provincia === idProvinciaSel)?.percepcion || null;
    //     } else {
    //         values[index]["percepcion"] = dataProvincia.percepcion || 0;
    //     }

    //     values[index]["id_provincia"] = event.target.value;
    //     values[index]["impuestoPadron"] = dataProvincia?.iibb_auto;
    //     values[index]["deshabilitaPercepcion"] = dataProvincia?.percepcion_fija == 1 || dataProvincia?.iibb_auto == 1;
    //     // console.log(dataProvincia)

    //     setInscrIIBB(values);
    // }

    async function preparar(e) {
        e.preventDefault();
        const reqBody = {
            exenciones:
                inscrIIBB.map((registro) => {
                    return {
                        cuit: String(cliente.cuit).trim(),
                        cuit_limpio: String(cliente.cuit).replace(/\D/g, ""),
                        id_provincia: registro.id_provincia,
                        porcentaje_excencion: registro.porcentaje_excencion || null,
                        vto_excencion: registro.vto_excencion || null,
                    };
                }) || [],
            inscripcionesInsert:
                inscrIIBB
                    .filter(
                        (registro) =>
                            !registro.id_inscripcion &&
                            (!!registro.id_provincia ||
                                // !!registro.percepcion ||
                                !!registro.porcentaje_excencion ||
                                !!registro.vto_excencion)
                    )
                    .map((registro) => {
                        return {
                            cuit: String(cliente.cuit).trim(),
                            cuit_limpio: String(cliente.cuit).replace(/\D/g, ""),
                            percepcion: registro.percepcion,
                            id_provincia: registro.id_provincia,
                            fecha_vigencia_desde: registro.fecha_vigencia_desde,
                            coeficiente_unificado: registro.coeficiente_unificado || 0,
                            id_ciclo_fiscal: cicloFiscalActual.id_ciclo //aca tiene q ir el ciclo fiscal actual
                        };
                    }) || [],
            inscripcionesUpdate: inscrIIBB.filter((itemActual) => {
                const original = clienteIIBBOriginal?.find(
                    (orig) => orig.id_provincia === itemActual.id_provincia
                );

                if (!original) return false;

                return (
                    original.id_provincia !== itemActual.id_provincia ||
                    original.percepcion !== itemActual.percepcion ||
                    original.coeficiente_unificado !== itemActual.coeficiente_unificado
                );
            }),
            eliminados:
                (clienteIIBBOriginal &&
                    clienteIIBBOriginal.filter(
                        (clienteOriginal) =>
                            !inscrIIBB.find(
                                (cliente) =>
                                    String(cliente.cuit).trim() ===
                                    String(clienteOriginal.cuit).trim() &&
                                    cliente.id_provincia === clienteOriginal.id_provincia
                            )
                    )) ||
                [],
        };

        // const errores = validar(
        //     reqBody.clienteIIBB,
        //     [],
        //     []
        //     // reqBody.excencionesDePadron,
        //     // reqBody.excencionesFueraPadron
        // );
        // if (errores.length > 0) {
        //     alert(errores.join("\n"));
        // } else {
        // save(reqBody, setNotify);
        guardarIibbCliente(reqBody, setNotify)
        // }
    }

    const childrenProps = {
        inscrIIBB,
        setShowCargaProxPeriodo,
        showAlertProxCiclo,
        configConvenio,
        almacenarImpuesto,
        deshacerAlmacenar,
        handleInputChange,
        provincias,
        handleInputChangeProvincia
    }

    const Children =
        <div>
            <Container maxWidth="xl" sx={{ p: 2 }}>
                {hayConvenio ? (
                    <>
                        {padronIIBB?.length == 1 && (
                            <PadronPercepcionesTabla registros={padronIIBB} />
                        )}
                        {padronIIBB?.length > 1 && (
                            <Alert
                                severity="info"
                                sx={{
                                    mx: 2,
                                    cursor: "pointer",
                                    backgroundColor: "#f8f9fa",
                                    color: "#2c3e50",
                                    borderColor: "#e0e0e0",
                                    transition: "all 0.2s ease-in-out",
                                    "& .MuiAlert-icon": {
                                        color: "#455a64",
                                    },
                                    "&:hover": {
                                        backgroundColor: "#e2e8f0",
                                        borderColor: "#b0bec5",
                                        boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.06)",
                                    },
                                }}
                                onClick={() => setOpenPadronDialog(true)}
                                action={
                                    <Button
                                        color="inherit"
                                        size="small"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setOpenPadronDialog(true);
                                        }}
                                    >
                                        Ver registros
                                    </Button>
                                }
                            >
                                <AlertTitle>Información de Padrón</AlertTitle>
                                El cliente figura en <strong>{padronIIBB?.length}</strong> registros
                                de padrón de percepciones/retenciones. Haz clic aquí para ver el
                                detalle.
                            </Alert>
                        )}
                        {showAlertProxCiclo && (
                            <Box sx={{ mb: 2 }}>
                                <Alert
                                    severity="warning"
                                    action={
                                        <Button color="inherit" size="small" onClick={() => setShowCargaProxPeriodo(true)}>
                                            Cargar
                                        </Button>
                                    }
                                >
                                    Por favor, carga los datos del próximo periodo.
                                </Alert>
                            </Box>
                        )}
                        <InscripcionesExclusionesForm {...childrenProps} />
                    </>
                ) : (
                    <AvisoNoHayConvenio />
                )}
            </Container>
            <Dialog
                open={openPadronDialog}
                onClose={() => setOpenPadronDialog(false)}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle sx={{ m: 0, p: 2, pr: 6 }}>
                    Padrón de Percepciones y Retenciones
                    <IconButton
                        aria-label="close"
                        onClick={() => setOpenPadronDialog(false)}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 2 }}>
                    <PadronPercepcionesTabla registros={padronIIBB} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenPadronDialog(false)} variant="outlined">
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>

    return (
        <div>
            <DialogoIngresosBrutos
                open={open}
                cliente={cliente}
                handleClose={() => setOpen(false)}
                preparar={preparar}
            >
                {Children}
            </DialogoIngresosBrutos>
            {notify.open ? (
                <Notify
                    open={notify.open}
                    color={notify.color}
                    severity={notify.severity}
                    mensaje={notify.mensaje}
                    handleClose={() => handleClose()}
                />
            ) : null}
        </div>
    )
}

